//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { saveAs } from "file-saver";
import mediaSubNav from "~/components/media-sub-nav";
import SocialShareBtns from "~/components/social-share-btns";
import { KinesisContainer, KinesisElement } from "vue-kinesis";
import audioBlock from "~/components/content-elements/audio-block";
export default {
  components: {
    saveAs,
    audioBlock,
    mediaSubNav,
    KinesisElement,
    SocialShareBtns,
    KinesisContainer,
  },
  data() {
    return {
      perPage: 9,
      currentPage: 1,
      canPlay: false,
      allPlayers: null,
      currentAudio: null,
      audioPlaying: false,
      currentFileSize: null,
      filters: {
        year: null,
        category: null,
      },
    };
  },
  async asyncData({ store }) {
    await store.dispatch("media/getBannerCustomization");
    const seo = store.state["media"].bannerCustomization.audio_seo;
    return { seo };
  },
  head() {
    return {
      title: this.seo.meta_title,
      meta: [
        {
          name: "description",
          hid: "description",
          content: this.seo.meta_description,
        },
        {
          name: "og:description",
          hid: "og:description",
          content: this.seo.meta_description,
        },
        {
          name: "keywords",
          hid: "keywords",
          content: this.seo.keywords,
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        {
          property: "og:image",
          hid: "og:image",
          content: this.seo.share_image_url,
        },
        {
          property: "og:title",
          hid: "og:title",
          content: this.seo.meta_title,
        },
        {
          property: "og:image:alt",
          hid: "og:image:alt",
          content: this.seo.share_image_alt,
        },

        {
          name: "shareImageAlt",
          hid: "shareImage",
          content: this.seo.share_image_alt,
        },
        {
          name: "shareImage",
          hid: "shareImage",
          content: this.seo.share_image_url,
        },
        {
          name: "preventindex",
          hid: "preventindex",
          content: this.seo.prevent_indexing,
        },
      ],
    };
  },
  methods: {
    downloadAudio(audio) {
      let filename = audio.split("/").pop();
      saveAs(audio, filename);
    },
    setEventListners() {
      let player = document.querySelector(".audio-waveform audio");
      player.addEventListener("playing", () => {
        this.audioPlaying = true;
      });
      player.addEventListener("pause", () => {
        this.audioPlaying = false;
      });
      player.addEventListener("pause", () => {
        this.canPlay = true;
      });
    },

    lodaModalData(data) {
      this.currentAudio = this.audios[data.index];
      this.currentFileSize = data.fileSize;
      this.$bvModal.show("audio-player-modal");
    },
    playAudio() {
      let player = document.querySelector(".audio-waveform audio");
      if (!this.audioPlaying) {
        player.play();
      } else {
        player.pause();
        //player.currentTime = 0;
      }
    },
    fetchData() {
      let data = {
        size: this.perPage,
        page: this.currentPage,
        year: this.filters.year != null ? this.filters.year : "",
        subCategory: this.filters.category != null ? this.filters.category : "",
      };
      this.$router.push({ path: "/media/audios", query: data });
      this.$store.dispatch("media/getAudioListening", data);
    },
    changeEv() {
      this.currentPage = 1;
    },
  },
  mounted() {
    this.currentPage =
      typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1;
    this.filters = {
      year:
        typeof this.$route.query.year != "undefined"
          ? this.$route.query.year
          : "",
      category:
        typeof this.$route.query.subCategory != "undefined"
          ? this.$route.query.subCategory
          : "",
    };
    this.$store.dispatch("media/getCategories");
    this.fetchData();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal) {
        this.$store.commit("media/CLEAR_AUDIO_LISTENING");
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.fetchData();
      }
    },
    $route(to) {
      this.size = 8;
      if (
        typeof to.query.page != "undefined" &&
        typeof to.query.year != "undefined" &&
        typeof to.query.subCategory != "undefined"
      ) {
        this.currentPage = to.query.page;
        this.filters.year = to.query.year;
        this.filters.category = to.query.subCategory;
        this.fetchData();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    },

    "filters.year": function () {
      this.$store.commit("media/CLEAR_AUDIO_LISTENING");
      this.fetchData();
    },
    "filters.category": function () {
      this.$store.commit("media/CLEAR_AUDIO_LISTENING");
      this.fetchData();
    },
  },
  computed: {
    categoriesData() {
      if (this.$store.state.media.categories != null) {
        return this.$store.state.media.categories.subCategories;
      }
    },
    audios() {
      if (this.$store.state["media"].audioListening) {
        return this.$store.state["media"].audioListening;
      }
    },
    audiosLength() {
      if (this.$store.state["media"].audioListening) {
        return this.$store.state["media"].audioListening.length;
      }
    },
  },
};
